export enum MenuOptionItemIntent {
  Default = "default",
  Primary = "primary",
  Danger = "danger",
}
